// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__Ex3BC","select":"Header_select__f3tdC","clinic":"Header_clinic__E5Oni"};